const AUTH0_ADMIN_RESET_USER_PASSWORD = '/dbconnections/change_password';
const CONNECTION = 'zosi-users';
const CLIENTS = '/clients';
const NAMESPACE = 'https://zosilearning.com/';
const GET_LIBRARY_DETAILS = '/library';

export {
  AUTH0_ADMIN_RESET_USER_PASSWORD,
  CONNECTION,
  CLIENTS,
  NAMESPACE,
  GET_LIBRARY_DETAILS,
};
